import React, { useEffect, useRef, useState } from "react";
import { IPaginacion } from "../../Interfaces/filter";
import {
  IDataTableEquipo,
  IFilterTableEquipo,
  initialFIlterTableEquipo,
} from "../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";
import { ISearchBox } from "@fluentui/react";
import EquipoService from "../../services/ListaVerificacion/EquipoService";
import { IException } from "../../Interfaces/base/IBase";

export const useTableEquipos = () => {
  const [loading, setLoading] = useState(false);
  const [dataTeble, setDataTeble] = useState<IDataTableEquipo[]>([]);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [filter, setFilter] = useState<IFilterTableEquipo>(
    initialFIlterTableEquipo
  );
  const onClickNext = () => {
    let valueSkip = filter.skip;
    setFilter({ ...filter, skip: valueSkip + 1 });
  };

  const onClickPrevius = () => {
    let valueSkip = filter.skip;
    setFilter({ ...filter, skip: valueSkip - 1 });
  };

  const searchBoxRefTable = useRef<ISearchBox>(null);

  const _onkeyUpSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const postDataTableEquipos = () => {
    EquipoService.PostLitarTablaEquipo(filter)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setDataTeble(res.data.items);
          setPaginacion({
            page: res.data.page,
            total: res.data.total,
            pages: res.data.pages,
          });
        } else {
          setLoading(false);
        }
      })
      .catch((err: IException) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onClickRefresh = () => {
    if (filter.search !== "") {
      setFilter(initialFIlterTableEquipo);
    } else {
      postDataTableEquipos();
    }
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    postDataTableEquipos();
  }, [filter]);

  return {
    loading,
    dataTeble,
    paginacion,
    onClickNext,
    onClickPrevius,
    searchBoxRefTable,
    _onkeyUpSearch,
    onClickRefresh,
    onChangeSkip,
  };
};
